import useTranslation from "next-translate/useTranslation";
import { useCallback, useMemo } from "react";
import Router from "next/router";
import Avatar from "@/components/common/Avatar";
import friendlySeconds from "@/utils/friendlySeconds";
import { setCache } from "@/utils/cache";
import CacheKeys from "@/common/models/CacheKeys";

const NotificationItem = ({
  id,
  notification,
  type,
  createdAt = Date.now(),
  handleClick,
  chatAvatarClassName = "h-9 w-9",
}) => {
  const { t } = useTranslation("common");
  const friendlyTime = useMemo(() => {
    const diff = Math.floor((Date.now() - new Date(createdAt).getTime()) / 1000);
    return t("common:format.time-ago", { time: friendlySeconds(diff, t) });
  }, [createdAt, t]);
  const openChat = useCallback(() => {
    setCache(CacheKeys.CHAT_RECEIVER_ID, notification.userId);
    setCache(CacheKeys.CHAT_ACTIVE, true);
  }, [notification.userId]);

  const onClick = () => {
    if (handleClick) handleClick();

    switch (type) {
      case "feature":
        Router.push(`/features#${id}`);
        break;
      case "chat":
        openChat();
        break;
      case "info":
        if (notification.link !== null) {
          window.location.assign(notification.link);
        }
        break;
      default:
    }
  };

  return (
    <div
      className="flex flex-grow justify-start items-center min-w-0 cursor-pointer select-none"
      onClick={onClick}
      role="presentation"
    >
      <Avatar
        className={`${chatAvatarClassName} flex-shrink-0`}
        image={notification.image}
        author={notification.name || notification.title}
      />
      <div className="flex flex-col flex-grow ml-3 min-w-0">
        <div className="flex justify-between items-center">
          <span className="flex-grow w-full text-xs font-semibold text-grey truncate">{notification.title}</span>
          <span className="flex-shrink-0 text-xs text-blue">{friendlyTime}</span>
        </div>
        <p className="mt-0.5 text-xs text-grey-800 break-words">{notification.message}</p>
      </div>
    </div>
  );
};

export default NotificationItem;
